<template>
	<div>
		<Modal :onClose="onClose">
			<div slot="header">Choose Channel</div>
			<form>
				<div class="form-detail">
					<div class="row">
						<div class="col-md-12">
							<div class="section section-adspreset-browser">
								<div class="list-group">
									<div class="list-item list-item-choices"
										v-for="(channel, index) in channels"
										:key="index"
										:class="{'active': isChoosen(channel)}"
										@click="onChoose(channel)">
										<div class="list-item-content list-item-primary">
											<div class="title">{{channel.name}}</div>
											<div class="sub-title">
												<a href="#">{{channel.description}}</a>
											</div>
										</div>
										<div class="list-item-actions">
											<div class="checkbox-round">
												<input type="checkbox" id="checkbox" :checked="isChoosen(channel)"/>
												<label for="checkbox"></label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</Modal>
	</div>
</template>

<script>
import _ from 'lodash';
import { getDateTime } from '@/modules/utilities';
import Modal from '@/components/elements/Modal';

export default {
	props: ['onClose', 'onSubmit', 'channels', 'currentChannel'],
	components: {
		Modal,
	},
	data() {
		return {
			selectedChannel: null,
		};
	},
	created() {
		this.selectedChannel = _.cloneDeep(this.currentChannel);
	},
	methods: {
		getDateTime,
		isChoosen(item) {
			return this.selectedChannel._id === item._id;
		},
		onChoose(item) {
			this.onSubmit(item);
		},
	},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/parts/channel/ChooseChannelModal.vue